export const css = {
    root: '_1noIvZfx',
    videoInstructions: '_34buWt0Q',
    videoWrapper: 'DcwtUet2',
    videoTranscript: '_1CPUTyzS',
    ' _key': 'video/video'
};
export default css;
